#### Mutation input field limits

A default maximum length for `String` mutation input fields is now documented in the SEEK API’s [request limits](/graphql/seek-api-conventions#request-limits).
Exceptions to this default are explicitly documented in the [GraphQL schema](/schema).

An operation containing an input field that exceeds its length limit will receive a [`BAD_USER_INPUT` error response](/graphql/error-responses#bad_user_input).
